import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoomsService } from 'src/app/services/rooms.service';
import { GenericsService } from 'src/app/services/generics.service';

@Component({
  selector: 'app-index-coworking',
  templateUrl: './index-coworking.component.html',
  styleUrls: ['./index-coworking.component.css']
})

/**
 * Coworking Component
 */
export class IndexCoworkingComponent implements OnInit {

  /**
   * Nav light class add
   */
  navClass = 'nav-light';
  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  showNavigationIndicators = false;
  rooms: any;
  sucursales: any;
  featuresOne: any;
  featuresTwo: any;
  featuresThree: any;
  ourPlans: any;
  whatWeDo: any;
  ourServices: any;
  menu: any;
  init = new EventEmitter();

  constructor(config: NgbCarouselConfig, 
    private modalService: NgbModal, 
    private roomsSrv: RoomsService, 
    private genericsSrv: GenericsService) {
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;
  }

  /**
   * Main Slider
   */
  customOptions: OwlOptions = {
    autoplay: true,
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    dots: false,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 1
      }
    },
    nav: false
  };

  customOptionsPlans: OwlOptions = {
    autoplay: true,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 1000,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 3
      }
    },
    nav: false
  };

  /**
   * Client Testimonial Data
   */
  testimonialData = [
    {
      profile: "assets/images/client/01.jpg",
      name: "Thomas Israel",
      designation: "C.E.O",
      message: `" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. "`
    },
    {
      profile: "assets/images/client/02.jpg",
      name: "Barbara McIntosh",
      designation: "M.D",
      message: `" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others. "`
    },
    {
      profile: "assets/images/client/03.jpg",
      name: "Carl Oliver",
      designation: "P.A",
      message: `" The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "`
    },
    {
      profile: "assets/images/client/04.jpg",
      name: "Christa Smith",
      designation: "Manager",
      message: `" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero. "`
    },
    {
      profile: "assets/images/client/05.jpg",
      name: "Dean Tolle",
      designation: "Developer",
      message: `" There is now an abundance of readable dummy texts. These are usually used when a text is required. "`
    },
    {
      profile: "assets/images/client/06.jpg",
      name: "Jill Webb",
      designation: "Designer",
      message: `" Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. "`
    }
  ];

  /**
   * Blog Data
   */
  blogData = [
    {
      image: "assets/images/blog/01.jpg",
      title: "Design your apps in your own way",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/02.jpg",
      title: "How apps is changing the IT world",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/03.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/03.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    }
  ];

  ngOnInit(): void {
    this.sucursales =  this.roomsSrv.getSucursales();
    this.rooms =  this.roomsSrv.getRooms().filter((room) => room.activeRoom === 1);
    this.featuresOne = this.genericsSrv.getfeatures().filter((feat) => feat.id < 4);
    this.featuresTwo = this.genericsSrv.getfeatures().filter((feat) => feat.id > 3 && feat.id < 7);
    this.featuresThree = this.genericsSrv.getfeatures().filter((feat) => feat.id > 6 && feat.id < 10);
    this.ourPlans = this.genericsSrv.getPlans();
    this.whatWeDo = this.genericsSrv.getWhat();
    this.ourServices = this.genericsSrv.getServices();
    this.menu = this.genericsSrv.getMenu();
  }
  
  ngAfterViewInit() {
    for (let index = 0; index < this.sucursales.length; index++) {
      this.loadMap(this.sucursales[index].coords,'mapSede-'+this.sucursales[index].id,this.sucursales[index].placeId);
    }
  }

  /**
  * Open modal for show the video
  * @param content content of modal
  */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

  loadMap(coords: any,divId: string,mapId: string){
    this.genericsSrv.initMap(coords,divId,mapId);
  }

  goToWs(){
    window.open("https://wa.me/584123218339", '_blank');
  }

}
